import { withNamespace } from "@/i18n/lazy-route"

/** The API keys screen (LLD §9.5, Task 2.1), loading the `apiKeys` namespace with its chunk. */
export const ApiKeysScreen = withNamespace("apiKeys", () => import("./screens/ApiKeysScreen"), {
  en: () => import("@/i18n/locales/en/apiKeys.json"),
  fr: () => import("@/i18n/locales/fr/apiKeys.json"),
})
